'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.logowall =
  twentyninetimes.logowall ||
  (function () {
    function init() {
      const logowalls = document.querySelectorAll('.block-logo-wall-wrapper');

      if (logowalls) {
        logowalls.forEach((block) => {
          const scrollContainer = block.querySelector('.block-logo-wall');
          const navigation = block.querySelector('.logo-wall-navigation');

          if (navigation) {
            const leftBtn = block.querySelector('.scroll-left');
            const rightBtn = block.querySelector('.scroll-right');

            leftBtn.addEventListener('click', function () {
              scrollContainer.scrollBy({ left: -200, behavior: 'smooth' }); // Scrolls left by 100px
            });

            rightBtn.addEventListener('click', function () {
              scrollContainer.scrollBy({ left: 200, behavior: 'smooth' }); // Scrolls right by 100px
            });
          }
        });
      }
    }

    return {
      init: init,
    };
  })();
